<template>
  <div class="layout layout--loading">
    <loader></loader>
  </div>
</template>

<script>
import Loader from '@vue-app/components/base/Loader.vue'

export default {
  name: 'loading-layout',
  components: { Loader },
}
</script>

<style lang="scss">
.layout {
  &--loading {
    position: absolute;
    width: 100vw;
    height: 100vh;

    display: flex;
    align-items: center !important;
    justify-content: center !important;
  }
}
</style>
